export const appArrowDown32Icon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.6667 10.6666L15.9746 21.3333L5.33334 10.6666" stroke="currentColor" stroke-width="8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-down-32'
};